import { Injectable } from '@angular/core';
import { AbstractOrganizationService } from './abstractOrganizationService';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { DomainName } from '../models/site';
import { Observable } from 'rxjs';
import { getPageParams, PageRequest, SpringPage } from '@shared/page';
import { PageParams } from './logs/logs.service';
import { buildHttpParams } from '@shared/utils/request-utils';
import { SiteRef, SiteShare } from './organization-site.service';
import { CustomPagesProfileModel } from '@shared/services/custom-page-profiles/organization-custom-pages-profile.service';
import { OrganizationBase } from '@shared/services/organization.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationSiteShareService extends AbstractOrganizationService {
  constructor(
    protected readonly http: HttpClient,
    auth: AuthService,
  ) {
    super(auth);
  }

  // Received shares

  public getReceivedSiteShares(
    query: { filter?: string },
    pageParams: PageParams,
  ): Observable<SpringPage<ReceivedSiteShare>> {
    return this.http.get<SpringPage<ReceivedSiteShare>>(this.url('/site-shares/received'), {
      params: buildHttpParams({ ...pageParams, ...query }),
    });
  }
  public getAvailableCustomPagesProfile(siteRef: SiteRef, pageRequest: PageRequest) {
    return this.http.get<SpringPage<CustomPagesProfileModel>>(
      this.siteUrl(siteRef) + '/available-custom-pages-profiles',
      {
        params: getPageParams(pageRequest),
      },
    );
  }
  public deleteReceivedSiteShare(siteRef: SiteRef) {
    return this.http.delete<void>(this.url(`/site-shares/received/${siteRef}`));
  }

  // Sent shares

  public getSentSiteShares(query: { filter?: string }, pageParams: PageParams): Observable<SpringPage<SentSiteShare>> {
    return this.http.get<SpringPage<SentSiteShare>>(this.url('/site-shares/sent'), {
      params: buildHttpParams({ ...pageParams, ...query }),
    });
  }

  // Share

  share(siteRef: SiteRef, recipient: string, role: SiteRole) {
    return this.http.put<SiteShare>(this.siteUrl(siteRef) + `/shares/${recipient}`, { role });
  }

  deleteShare(siteRef: SiteRef, recipient: string) {
    return this.http.delete<SiteShare>(this.siteUrl(siteRef) + `/shares/${recipient}`);
  }

  private siteUrl(siteRef: SiteRef) {
    return this.sitesUrl() + '/' + siteRef;
  }

  private sitesUrl() {
    return this.url('/sites');
  }
}

type SiteRole = 'VIEW' | 'ADMIN';

export type ReceivedSiteShare = {
  site: DomainName;
  sender: OrganizationBase;
  role: SiteRole;
};

export type SentSiteShare = {
  site: DomainName;
  recipient: OrganizationBase;
  role: SiteRole;
};
